<script setup>
import { computed, provide, inject } from 'vue'
import { createReusableTemplate } from '@vueuse/core'
import FieldLayout from './simpleSchema/layouts/field.vue'
import CheckboxLayout from './simpleSchema/layouts/checkbox.vue'
import RadiosLayout from './simpleSchema/layouts/radios.vue'
import { useSimpleSchema } from './simpleSchema'
defineOptions({
  inheritAttrs: false,
})
const mdl = defineModel({})
const propz = defineProps({
  simplsch: { type: [Array, String], default: () => [] },
  obj: Object,
})

const keyPrefix = inject('ss:key-prefix', null)
const { sref, sshow } = useSimpleSchema(
  computed(() => propz.simplsch),
  mdl,
  keyPrefix
)

const [DfnCmpTpl, UseCmpTpl] = createReusableTemplate({ inheritAttrs: false })

const layouts = {
  checkbox: CheckboxLayout,
  radio: CheckboxLayout,
  radios: RadiosLayout,
}

provide('ss:model', mdl)
</script>
<template>
  <dfn-cmp-tpl #="{ ctrl, id, props, model, fn, children, label }">
    <component
      v-bind="{ ...props, label }"
      :is="ctrl"
      :id="id"
      :model-value="model.value"
      @update:model-value="fn"
    >
      <SimpleSchema
        :simplsch="children"
        v-if="children.length"
        :model-value="mdl"
        @update:model-value="mdl = $event"
      />
    </component>
  </dfn-cmp-tpl>

  <template v-for="[ctrl, id, props, model, fn, label, children, fname] of sref" :key="id">
    <template v-if="sshow[fname] != false">
      <use-cmp-tpl
        :ctrl="ctrl"
        :id="id"
        :props="props"
        :model="model"
        :fn="fn"
        :children="children"
        :fname="fname"
        :label="label"
        v-if="props.layout === false"
      />
      <component
        :is="layouts[ctrl.__name] ?? FieldLayout"
        :control-id="id"
        :class="props.layout"
        v-else
      >
        <template #label v-if="label">{{ label }}</template>
        <template #control>
          <use-cmp-tpl
            :ctrl="ctrl"
            :id="id"
            :props="props"
            :model="model"
            :fn="fn"
            :children="children"
          />
        </template>
      </component>
    </template>
  </template>
</template>
